import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { INTERVENINGNAME } from '@shared/models/constants/interveningType';
import { Intervener, Witness } from '@shared/models/interfaces/survey.interface';

@Component({
  selector: 'app-detail-signatures',
  templateUrl: './detail-signatures.component.html',
  styleUrls: ['./detail-signatures.component.scss'],
})
export class DetailSignaturesComponent {
  @Input() dataList: Intervener[] | Witness[];
  @Input() title: string;
  @Input() noDataTitle: string;
  @Input() type: 'intervener' | 'witness';

  public IntervenerTypeName = INTERVENINGNAME;

  constructor(private translate: TranslateService) {}

  getItemName(item: Intervener | Witness): string {
    if (this.type === 'intervener') {
      return (item as Intervener).intervenerName;
    } else {
      return (item as Witness).witnessName;
    }
  }

  getSignedStatus(item: Intervener | Witness): string {
    if (this.type === 'intervener') {
      const intervener = item as Intervener;
      return intervener.intervenerHasSigned
        ? `${this.translate.instant('SURVEYS.DETAILS.SIGNED_AS')} ${this.translate.instant(
            this.IntervenerTypeName[intervener.intervenerTypeId],
          )}`
        : 'SURVEYS.DETAILS.NOT_SIGNED';
    } else {
      return (item as Witness).witnessHasSigned ? 'SURVEYS.DETAILS.SIGNED' : 'SURVEYS.DETAILS.NOT_SIGNED';
    }
  }
}
